import { Injectable, inject } from '@angular/core';
import { filter, map, Observable } from 'rxjs';
import { JsonLdBuilder } from '../../structured-data.model';
import { BoelsPointOfService } from '@boels/models';
import { UrlSafePipe } from '@boels/helpers';
import { CultureFacade } from '@boels/shared-state';

type PointOfService = {
  '@id'?: string;
  name?: string;
  telephone?: string;
  url?: string;
  image?: string;
};

@Injectable()
export class JsonldLocalBusinessBaseBuilder
  implements JsonLdBuilder<BoelsPointOfService>
{
  private urlSafePipe = inject(UrlSafePipe);
  private cultureFacade = inject(CultureFacade);

  build(boelsPointOfService: BoelsPointOfService): Observable<PointOfService> {
    return this.cultureFacade.getActiveCulture().pipe(
      filter((culture) => !!culture),
      map((activeCulture: string) => ({
        ...this.getLocalBusinessBase(boelsPointOfService, activeCulture),
        ...this.getLocalBuisnessImage(),
      })),
    );
  }

  private getLocalBusinessBase(
    boelsPointOfService: BoelsPointOfService,
    activeCulture: string,
  ): { '@id'?: string; name?: string; telephone?: string; url?: string } {
    const result: PointOfService = {};

    if (boelsPointOfService.name) {
      result['@id'] = `www.boels.com/branches/${boelsPointOfService.name}`;
    }
    if (boelsPointOfService.displayName) {
      result.name = `Boels ${boelsPointOfService.displayName}`;
    }
    if (boelsPointOfService.address?.phone) {
      result.telephone = boelsPointOfService.address.phone;
    }
    if (
      boelsPointOfService.address?.region?.name &&
      boelsPointOfService.displayNameSlug &&
      boelsPointOfService.baseSites?.[0]?.baseSiteUrl
    ) {
      result.url = `${
        boelsPointOfService.baseSites[0].baseSiteUrl
      }/${activeCulture}/branches/${this.urlSafePipe.transform(
        boelsPointOfService.address.region.name,
      )}/${boelsPointOfService.displayNameSlug}`;
    }
    return result;
  }

  protected getLocalBuisnessImage(): { image?: string } {
    const image =
      'https://mediahub.boels.com/m/6f5e901208702d82/online-boels-rental-logo.png';
    return image ? { image } : {};
  }
}
